// extracted by mini-css-extract-plugin
module.exports = {"namespace":"v","elNamespace":"el"};